export const cibManjaro = ["32 32","<path d='M0 0v32h9v-23h11.5v-9zM11.5 11.5v20.5h9v-20.5zM23 0v32h9v-32z'/>"]